/**
 * This container in the planner's preview: by its id, else the one whose
 * drops carry the draft's slot ids (an all-lists drop names its slot row).
 * Empty when the container has not been saved or planned yet.
 * For Media Devoted | Created By Ciro Autiero
 */
import type { DayPlanContainerRow, DayPlanDropRow, DayPlanGroupRow } from '@trafficpulse/shared';

import type { DraftSlot } from '../../../../../../drop-generator.types';

export function previewOf(
  containers: DayPlanContainerRow[],
  slots: DraftSlot[],
  containerId: string | null = null,
): { drops: DayPlanDropRow[]; groups: DayPlanGroupRow[] } {
  const ids = new Set(slots.map((s) => s.id).filter((id): id is string => id !== null));
  // By its id first — a container with no drop today still has its groups (today's set, "no list today").
  const mine =
    containers.find((c) => containerId !== null && c.containerId === containerId) ??
    containers.find((c) => c.drops.some((d) => (d.slotId !== null && ids.has(d.slotId)) || (d.slotRowId !== undefined && ids.has(d.slotRowId))));
  return { drops: mine?.drops ?? [], groups: mine?.groups ?? [] };
}
